import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import React, { Suspense, lazy, useEffect, useState } from 'react';
import { LanguageProvider } from './contexts/LanguageContext';
import './App.css';
import BottomNav from './components/BottomNav';

const SplashScreen = lazy(() => import('./components/SplashScreen'));
const Home = lazy(() => import('./pages/Home'));
const Products = lazy(() => import('./pages/Products'));
const Membership = lazy(() => import('./pages/Membership'));
const Referrals = lazy(() => import('./pages/Referrals'));
const Mask = lazy(() => import('./pages/Mask'));
const Oil = lazy(() => import('./pages/Oil'));
const GuaSha = lazy(() => import('./pages/GuaSha'));
const CleansingWater = lazy(() => import('./pages/CleansingWater'));
const Game = lazy(() => import('./pages/Game'));
const GameLeaderBoard = lazy(() => import('./pages/GameLeaderBoard'));
const SnakeGame = lazy(() => import('./pages/Snake'));
const MemberSearchPngPage = lazy(() => import('./pages/MemberSearchPngPage'));
const OrderItems = lazy(() => import('./pages/OrderItems'));
const VideoStories = lazy(() => import('./pages/VideoStories'));

const RouteFallback = () => (
  <div className="min-h-[90svh] bg-botum-cream flex items-center justify-center px-6">
    <div className="h-2 w-32 overflow-hidden rounded-full bg-botum-mist">
      <div className="h-full w-1/2 animate-[shimmer_1.2s_infinite] rounded-full bg-botum-primary" />
    </div>
  </div>
);

function AppContent({ showSplash, setShowSplash }) {
  const location = useLocation();
  const isSnakeRoute = location.pathname === '/snake';
  const isReceiptRoute = location.pathname.startsWith('/items');
  const isStoriesRoute = location.pathname === '/stories';

  return (
    <div className="min-h-screen bg-botum-cream">
      <Suspense fallback={<RouteFallback />}>
        {showSplash && !isReceiptRoute && !isStoriesRoute && <SplashScreen onFinish={() => setShowSplash(false)} />}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/membership" element={<Membership />} />
          <Route path="/referrals" element={<Referrals />} />
          <Route path="/mask" element={<Mask />} />
          <Route path="/oil" element={<Oil />} />
          <Route path="/guasha" element={<GuaSha />} />
          <Route path="/cleansing-water" element={<CleansingWater />} />
          <Route path="/game" element={<Game />} />
          <Route path="/game-leaderboard" element={<GameLeaderBoard />} />
          <Route path="/snake" element={<SnakeGame />} />
          <Route path="/member-search" element={<MemberSearchPngPage />} />
          <Route path="/items" element={<OrderItems />} />
          <Route path="/items/:orderId" element={<OrderItems />} />
          <Route path="/stories" element={<VideoStories />} />
        </Routes>
      </Suspense>
      {!isSnakeRoute && !isReceiptRoute && !isStoriesRoute && <BottomNav />}
    </div>
  );
}

function App() {
  const [showSplash, setShowSplash] = useState(false);

  useEffect(() => {
    const checkSplash = () => {
      const lastSeen = localStorage.getItem('botum_splash_seen');
      const now = new Date().getTime();
      const threeDays = 3 * 24 * 60 * 60 * 1000;

      if (!lastSeen || (now - parseInt(lastSeen)) > threeDays) {
        setShowSplash(true);
        localStorage.setItem('botum_splash_seen', now.toString());
      }
    };
    
    checkSplash();
  }, []);

  return (
    <LanguageProvider>
      <Router>
        <AppContent showSplash={showSplash} setShowSplash={setShowSplash} />
      </Router>
    </LanguageProvider>
  );
}

export default App;
